import AbkLogoKurz from "../../../assets/images/ABK-KP-logo.jpg"
import {colors} from "../../../theme";

export default function ABKHeader() {
    return (
        <div style={{width: "100%", backgroundColor: colors.gruen, display: "flex", alignItems: "center"}}>
            <img src={AbkLogoKurz} alt=""/>
        </div>
    );
}
